<div class="layout">
  <a class="skip-link" href="#main-content">{{ "shell.SKIP_TO_CONTENT" | translate }}</a>
  <app-header></app-header>
  <main id="main-content" class="content">
    <ng-content></ng-content>
  </main>
  @if (!hideFooter()) {
    @if (useCompactFooter()) {
      <app-compact-footer></app-compact-footer>
    } @else {
      <app-footer></app-footer>
    }
  }
</div>
